export const shortFieldStyles = {
  wrapper: {
    width: '200px',
    '& .MuiFormLabel-root.Mui-error ': { overflow: 'initial' },
  },
};
